import CustomButton from "@/components/common/Button";
import { UploadService } from "@/services/APIs";
import { UploadOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import { UploadProps } from "antd/es/upload";
import { useState } from "react";

export const CustomUpload = (props: UploadProps) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const handleUpload = async (files: File[]) => {
    const response = await UploadService.uploadFiles({
      folderName: "uploads",
      files,
    });
    if (response) {
      console.log(response);
    }
  };
  const handleFileSelect = (file: File) => {
    setSelectedFile(file);
    return false; // Prevent default upload
  };

  const handleUploadToServer = async () => {
    if (!selectedFile) {
      return;
    }

    await handleUpload([selectedFile]);
  };

  const handleChange = (info: any) => {
    // Only handle file selection, not upload
    if (info.file.status === "removed") {
      setSelectedFile(null);
    }
  };

  return (
    <div className="space-y-2">
      <Upload
        {...props}
        beforeUpload={handleFileSelect}
        onChange={handleChange}
        showUploadList={false}
      >
        <CustomButton icon={<UploadOutlined />} title="Select File to Upload">
          Select File
        </CustomButton>
      </Upload>

      {selectedFile && (
        <div className="rounded border border-blue-200 bg-blue-50 p-2">
          <div className="flex items-center justify-between">
            <span className="text-sm text-blue-800">{selectedFile.name}</span>
            <CustomButton
              type="primary"
              size="small"
              loading={false}
              onClick={handleUploadToServer}
              title="Upload Selected File"
            >
              Upload
            </CustomButton>
          </div>
        </div>
      )}
    </div>
  );
};
